import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";
import { TwitterTimelineEmbed, TwitterFollowButton } from "react-twitter-embed";

import { h2 } from "~/styles/typographyStyles";

const Wrapper = styled.aside`
    background-color: ${({ theme }) => theme.colors.backgroundColor.section};
`;

const Header = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 30px 20px 15px;
`;

const FollowWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const Title = styled.h2`
    ${h2};
    margin-bottom: 0;
`;

const Content = styled.div`
    padding: 0 20px;
`;

const TwitterTimeline = ({ screenName, title = "", height = 700 }) => (
    <Wrapper {...{ height }}>
        <Header>
            <Title>{title ? title : "Tweets"}</Title>
            <FollowWrapper>
                <TwitterFollowButton {...{ screenName }} />
            </FollowWrapper>
        </Header>
        <Content>
            <TwitterTimelineEmbed
                {...{ screenName }}
                sourceType="profile"
                options={{ height: height ?? 700 }}
                transparent
                noHeader
                noFooter
                noBorders
            />
        </Content>
    </Wrapper>
);

TwitterTimeline.propsTypes = {
    screenName: PropTypes.string.isRequired,
    title: PropTypes.string,
    height: PropTypes.number,
};

export default TwitterTimeline;
